module.exports = __webpack_public_path__ + "img/1920_icon_homepage_booking.2fa731af.svg";